import React, { useState, useEffect } from "react";
import "./DetailCalc.css";
import {
  Col,
  Container,
  Form,
  Row,
  Accordion,
  Table,
  Button,
  FloatingLabel,
} from "react-bootstrap";

const DetailsCalc = () => {
  const [dateType, setDateType] = useState("Annually");
  const dateTypes = [
    { value: "Annually" },
    { value: "Monthly" },
    { value: "Fortnight" },
    { value: "Weakly" },
    { value: "Daily" },
    { value: "Hourly" },
  ];
  const [frequency, setFrequency] = useState("Year");
  const frequencys = [
    { value: "Year" },
    { value: "Monthly" },
    { value: "Fortnight" },
    { value: "Weakly" },
    { value: "Percent" },
  ];

  const [frequencyTwo, setFrequencyTwo] = useState("Year");
  const frequencysTwo = [
    { value: "Year" },
    { value: "Monthly" },
    { value: "Fortnight" },
    { value: "Weakly" },
    { value: "Percent" },
  ];

  const [frequencyThree, setFrequencyThree] = useState("Year");
  const frequencysThree = [
    { value: "Year" },
    { value: "Monthly" },
    { value: "Fortnight" },
    { value: "Weakly" },
  ];

  // const [optionCheck, setOptionCheck] = useState([
  //   {
  //     id: "1",
  //     label: "Includes Superannuation",
  //     isChecked: false,
  //     value: "superannuation",
  //   },
  //   {
  //     id: "2",
  //     label: "Student loan",
  //     isChecked: false,
  //     value: "student-loan",
  //   },
  // ]);
  const [income, setIncome] = useState(0);
  const [annuallyTaxableIncome, setAnnuallyTaxableIncome] = useState(0);
  const [monthlyTaxableIncome, setMonthlyTaxableIncome] = useState(0);
  const [fortnightlyTaxableIncome, setFortnightlyTaxableIncome] = useState(0);
  const [weaklyTaxableIncome, setWeaklyTaxableIncome] = useState(0);
  const [dailyTaxableIncome, setDailyTaxableIncome] = useState(0);

  const [salarySacrifice, setSalarySacrifice] = useState(0);
  const [annuallySalarySacrifice, setannuallySalarySacrifice] = useState(0);
  const [monthlySalarySacrifice, setmonthlySalarySacrifice] = useState(0);
  const [fortnightlySalarySacrifice, setfortnightlySalarySacrifice] =
    useState(0);
  const [weaklySalarySacrifice, setweaklySalarySacrifice] = useState(0);
  const [percentSalarySacrifice, setpercentSalarySacrifice] = useState(0);

  const [superannuation, setSuperannuation] = useState(10);
  const [noSuperAnnuation, setNoSuperAnnuation] = useState(false);
  const [incomeSacrifice, setincomeSacrifice] = useState(false);
  const [voluntarySuperAnnuation, setVoluntarySuperAnnuation] = useState(false);
  const [voluntary, setVoluntary] = useState(0);
  const [over71, setOver71] = useState(false);
  const [coContribution, setcoContribution] = useState(false);

  const [nonResident, setNonResident] = useState(false);
  const [workHoliDay, setWorkHoliDay] = useState(false);
  const [noTaxFree, setNoTaxFree] = useState(false);

  const [includesSup, setIncludesSup] = useState(0);
  const [studentLoan, setStudentLoan] = useState(false);

  const [carryForward, setCarryForward] = useState(false);
  const [contribution, setContribution] = useState(false);
  const [overSixtyFive, setOverSixtyFive] = useState(false);
  const [renderMe, setRenderMe] = useState(false);

  /* const [partTime, setPartTime] = useState(false);
  const [partTimeValue, setPartTimeValue] = useState("Hours");
  const partTimeShortValues = [{ value: "Hours" }, { value: "Days" }];
  const [partTimeLongValue, setPartTimeLongValue] = useState("Weakly");
  const partTimeLongValues = [{ value: "Weakly" }, { value: "Fortnight" }];
  const [partTimeTex, setpartTimeTex] = useState(0); */

  const [mediCare, setMedicare] = useState(false);
  const [dependent, setDependent] = useState(false);
  const [spouse, setSpouse] = useState(false);
  const [sapto, setSapto] = useState(false);

  /* Deductions, income Sacrifice & Other income */
  const [deductions, setDeductions] = useState();

  const [salarySacrafice, setSalarySacrafice] = useState(0);
  const [annuallySalarySacrafice, setannuallySalarySacrafice] = useState(0);
  const [monthlySalarySacrafice, setmonthlySalarySacrafice] = useState(0);
  const [fortnightlySalarySacrafice, setfortnightlySalarySacrafice] =
    useState(0);
  const [weaklySalarySacrafice, setweaklySalarySacrafice] = useState(0);
  const [percentSalarySacrafice, setpercentSalarySacrafice] = useState(0);

  const [allowances, setAllowances] = useState(0);
  const [annuallyAllowances, setAnnuallyAllowances] = useState(0);
  const [monthlyAllowances, setMonthlyAllowances] = useState(0);
  const [fortnightlyAllowances, setFortnightlyAllowances] = useState(0);
  const [weaklyAllowances, setWeaklyAllowances] = useState(0);

  const [capitalGains, setCapitalGains] = useState();
  const [otherIncome, setOtherIncome] = useState();
  const [businessIncome, setBusinessIncome] = useState();
  const [taxCredits, setTaxCredits] = useState();

  //part time
  /* const partTimegetData = (e) => {
    setPartTimeValue(e);
    setRenderMe(!renderMe);
    // console.log("check", dateType);
  };

  const partTimeLongGetData = (e) => {
    setPartTimeLongValue(e);
    setRenderMe(!renderMe);
    // console.log("check", dateType);
  };
  switch (partTimeLongValue) {
    case "Hours":
      break;
    case "Weakly":
      break;
    default:
    // code block
  } */

  //income
  const getData = (e) => {
    setDateType(e);
    setRenderMe(!renderMe);
    // console.log("check", dateType);
  };

  //secrifice
  const getDataFrequency = (e) => {
    setFrequency(e);
    setRenderMe(!renderMe);
    // console.log("check", dateType);
  };

  //Salary Sacrifice arrangment not including salary sacrificed super
  const getDataFrequencyTwo = (e) => {
    setFrequencyTwo(e);
    setRenderMe(!renderMe);
    // console.log("check", dateType);
  };

  //Allowances
  const getDataFrequencyThree = (e) => {
    setFrequencyThree(e);
    setRenderMe(!renderMe);
    // console.log("check", dateType);
  };

  useEffect(() => {
    switch (dateType) {
      case "Annually":
        setAnnuallyTaxableIncome(income);
        setMonthlyTaxableIncome(income / 12);
        setFortnightlyTaxableIncome(income / 26);
        setWeaklyTaxableIncome(income / 52);
        break;
      case "Monthly":
        setAnnuallyTaxableIncome(income * 12);
        setMonthlyTaxableIncome(income);
        setFortnightlyTaxableIncome(income * 0.23 * 2);
        setWeaklyTaxableIncome(income * 0.23);
        break;
      case "Fortnight":
        setFortnightlyTaxableIncome(income);
        setAnnuallyTaxableIncome(income * 26);
        setMonthlyTaxableIncome(income * 2.17);
        setWeaklyTaxableIncome(income * 0.5);
        break;
      case "Weakly":
        setWeaklyTaxableIncome(income);
        setAnnuallyTaxableIncome(income * 52);
        setMonthlyTaxableIncome(income * 4.33);
        setFortnightlyTaxableIncome(income * 2);
        break;
      case "Daily":
        setDailyTaxableIncome(income);
        setWeaklyTaxableIncome(income * 5);
        setFortnightlyTaxableIncome(income * 10);
        setMonthlyTaxableIncome(income * 21.67);
        setAnnuallyTaxableIncome(income * 260);
        break;
      case "Hourly":
        setDailyTaxableIncome(income * 7.6);
        setWeaklyTaxableIncome(income * 38);
        setFortnightlyTaxableIncome(income * 76);
        setMonthlyTaxableIncome(income * 164.67);
        setAnnuallyTaxableIncome(income * 1976);
        break;
      default:
      // code block
    }
    switch (frequency) {
      case "Year":
        setannuallySalarySacrifice(salarySacrifice);
        setmonthlySalarySacrifice(salarySacrifice / 12);
        setfortnightlySalarySacrifice(salarySacrifice / 26);
        setweaklySalarySacrifice(salarySacrifice / 52);
        setpercentSalarySacrifice(salarySacrifice / 100);
        break;
      case "Monthly":
        setmonthlySalarySacrifice(salarySacrifice);
        setannuallySalarySacrifice(salarySacrifice / 12);
        setfortnightlySalarySacrifice(salarySacrifice * 0.46);
        setweaklySalarySacrifice(salarySacrifice * 0.23);

        break;
      case "Fortnight":
        setfortnightlySalarySacrifice(salarySacrifice);
        setannuallySalarySacrifice(salarySacrifice * 26);
        setmonthlySalarySacrifice(salarySacrifice * 2.17);
        setweaklySalarySacrifice(salarySacrifice * 0.5);

        break;
      case "Weakly":
        setweaklySalarySacrifice(salarySacrifice);
        setfortnightlySalarySacrifice(salarySacrifice * 2);
        setmonthlySalarySacrifice(salarySacrifice * 4.33);
        setannuallySalarySacrifice(salarySacrifice * 52);

        break;
      case "Percent":
        setpercentSalarySacrifice(salarySacrifice);
        setweaklySalarySacrifice(salarySacrifice / 100);
        setfortnightlySalarySacrifice(salarySacrifice / 100);
        setmonthlySalarySacrifice(salarySacrifice / 100);
        setannuallySalarySacrifice(salarySacrifice / 100);
        break;

      default:
        break;
    }
    switch (frequencyTwo) {
      case "Year":
        setannuallySalarySacrafice(salarySacrafice);
        setmonthlySalarySacrafice(salarySacrafice / 12);
        setfortnightlySalarySacrafice(salarySacrafice / 26);
        setweaklySalarySacrafice(salarySacrafice / 52);
        setpercentSalarySacrafice(salarySacrafice / 100);
        break;
      case "Monthly":
        setannuallySalarySacrafice(salarySacrafice / 12);
        setmonthlySalarySacrafice(salarySacrafice);
        setfortnightlySalarySacrafice(salarySacrafice / 14);
        setweaklySalarySacrafice(salarySacrafice / 7);
        setpercentSalarySacrafice(salarySacrafice / 12);

        break;
      case "Fortnight":
        setannuallySalarySacrafice(salarySacrafice / 12);
        setmonthlySalarySacrafice(salarySacrafice / 30);
        setfortnightlySalarySacrafice(salarySacrafice);
        setweaklySalarySacrafice(salarySacrafice / 7);
        setpercentSalarySacrafice(salarySacrafice / 100);

        break;
      case "Weakly":
        setannuallySalarySacrafice(salarySacrafice / 12);
        setmonthlySalarySacrafice(salarySacrafice / 30);
        setfortnightlySalarySacrafice(salarySacrafice / 14);
        setweaklySalarySacrafice(salarySacrafice / 52);
        setpercentSalarySacrafice(salarySacrafice / 100);

        break;
      case "Percent":
        setannuallySalarySacrafice(salarySacrafice * 12);
        setmonthlySalarySacrafice(salarySacrafice * 12);
        setfortnightlySalarySacrafice(salarySacrafice * 26);
        setweaklySalarySacrafice(salarySacrafice * 52);
        setpercentSalarySacrafice(salarySacrafice);
        break;

      default:
        break;
    }
    switch (frequencyThree) {
      case "Year":
        setAnnuallyAllowances(allowances);
        break;
      case "Monthly":
        setAnnuallyAllowances(allowances * 2);
        setMonthlyAllowances(allowances);

        break;
      case "Fortnight":
        setAnnuallyAllowances(allowances * 26);
        setMonthlyAllowances(allowances * 2 + 1.83);
        setFortnightlyAllowances(allowances);

        break;
      case "Weakly":
        setAnnuallyAllowances(allowances * 52);
        setMonthlyAllowances(allowances * 4 + 3.67);
        setFortnightlyAllowances(allowances * 2);
        setWeaklyAllowances(allowances);

        break;

      default:
        break;
    }
  }, [
    income,
    dateType,
    salarySacrifice,
    frequency,
    salarySacrafice,
    frequencyTwo,
    allowances,
    frequencyThree,
  ]);

  //daynamic added input field
  /* const [overTime, setOverTime] = useState([]);

  let handleChange = (i, e) => {
    let newOverTimes = [...overTime];
    newOverTimes[i][e.target.hours] = e.target.value;
    setOverTime(newOverTimes);
  };

  let addFormFields = () => {
    setOverTime([...overTime, { hours: "", email: "" }]);
  };

  let removeFormFields = (i) => {
    let newOverTimes = [...overTime];
    newOverTimes.splice(i, 1);
    setOverTime(newOverTimes);
  };

  let handleSubmit = (event) => {
    event.preventDefault();
    alert(JSON.stringify(overTime));
  }; */

  // income form
  // const handleOnChange = (e) => {
  //   e.preventDefault();
  //   // console.log("called", dateType);
  //   console.log(income);
  // };

  console.log([
    // { dateType },
    // { income },
    // { annuallyTaxableIncome },
    // { weaklyTaxableIncome },
    // { fortnightlyTaxableIncome },
    // { monthlyTaxableIncome },
    // { partTimeText: partTimeTex },
    // { salarySacrifice },
    // { frequency },
    // { voluntary },
    { deductions },
    { salarySacrafice },
  ]);

  return (
    <>
      <Container>
        <Row className="mt-3">
          <Col md={6} sm={12}>
            <Row>
              <Col md={8} xs={12}>
                <FloatingLabel
                  controlId="floatingInput"
                  label={
                    dateType === "Daily" || dateType === "Hourly"
                      ? dateType + " Rate"
                      : dateType + " Salary"
                  }
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="0.00"
                    defaultValue={income}
                    onChange={(e) => setIncome(Number(e.target.value))}
                  />
                </FloatingLabel>
              </Col>
              <Col md={4} xs={12}>
                {/* <Form.Label>Per Cycle</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  onChange={(e) => getData(e.target.value)}
                >
                  {dateTypes.map((data) => (
                    <option defaultValue={data.value} key={data.value}>
                      {data.value}
                    </option>
                  ))}
                </Form.Select> */}

                <FloatingLabel controlId="floatingSelectGrid" label="Per Cycle">
                  <Form.Select
                    aria-label="Default select example"
                    onChange={(e) => getData(e.target.value)}
                  >
                    {dateTypes.map((data) => (
                      <option defaultValue={data.value} key={data.value}>
                        {data.value}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
            </Row>

            {/* PartTime */}
            {/* <Row className="ms-1 mb-1">
              <div className="form-check form-switch">
                <input
                  onClick={() => setPartTime(!partTime)}
                  className="form-check-input"
                  type="checkbox"
                  value="income-sacrifice"
                  id="income-sacrifice"
                />
                <label className="form-check-label">Pro-rata / Part-time</label>
              </div>
              {partTime ? (
                <Row className="my-5">
                  <Col md={4}>
                    <div className="form-group">
                      <label>Days</label>
                      <input
                        type="text"
                        className="form-control"
                        id="sacrifice-amount"
                        defaultValue={partTimeTex}
                        onChange={(e) => setpartTimeTex(Number(e.target.value))}
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="form-group">
                      <label htmlFor=""></label>
                      <Form.Select
                        aria-label="Default select example"
                        onChange={(e) => partTimegetData(e.target.value)}
                      >
                        {partTimeShortValues.map((data) => (
                          <option defaultValue={data.value} key={data.value}>
                            {data.value}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="form-group">
                      <label htmlFor="">Each</label>
                      <Form.Select
                        aria-label="Default select example"
                        onChange={(e) => partTimeLongGetData(e.target.value)}
                      >
                        {partTimeLongValues.map((data) => (
                          <option defaultValue={data.value} key={data.value}>
                            {data.value}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                  </Col>
                </Row>
              ) : null}
            </Row> */}

            {/* OverTime */}
            {/* <div>
              <form onSubmit={handleSubmit}>
                {overTime.map((element, index) => (
                  <div className="form-inline" key={index}>
                    {index ? (
                      <Row>
                        <Col md={4}>
                          <div className="form-group">
                            <label>Hours</label>
                            <input
                              type="number"
                              className="form-control"
                              id="sacrifice-amount"
                              placeholder="00.00"
                              onChange={(e) => handleChange(index, e)}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <label>Rate</label>
                            <input
                              type="number"
                              className="form-control"
                              id="sacrifice-amount"
                              placeholder="00.00"
                              onChange={(e) => handleChange(index, e)}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <label htmlFor="">Each</label>
                            <Form.Select
                              aria-label="Default select example"
                              onChange={(e) => handleChange(index, e)}
                            >
                              <option value="1">Week</option>
                              <option value="2">Fortnightly</option>
                              <option value="3">Monthly</option>
                              <option value="4">Annually</option>
                            </Form.Select>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <label>Weeks</label>
                            <input
                              type="number"
                              className="form-control"
                              id="sacrifice-amount"
                              placeholder="52"
                              onChange={(e) => handleChange(index, e)}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <label>Each</label>
                            <input
                              type="number"
                              className="form-control"
                              id="sacrifice-amount"
                              placeholder="Year"
                              onChange={(e) => handleChange(index, e)}
                            />
                          </div>
                        </Col>
                      </Row>
                    ) : null}
                    <div>
                      {index ? (
                        <button
                          type="button"
                          className="button remove mt-2"
                          onClick={() => removeFormFields(index)}
                        >
                          Remove
                        </button>
                      ) : null}
                    </div>
                  </div>
                ))}
                <div
                  className="button-section my-3"
                  style={{ paddingLeft: "0px" }}
                >
                  <button
                    className="button add"
                    type="button"
                    onClick={() => addFormFields()}
                  >
                    OVERTIME
                  </button>
                </div>
              </form>
            </div> */}
          </Col>
          {/* Options */}
          <Col md={6} sm={12}>
            <p className="mb-2" style={{ color: "green" }}>
              Options
            </p>
            <hr className="mt-0" style={{ color: "green" }} />
            <div className="form-check form-switch">
              <input
                onClick={() => setIncludesSup(!includesSup)}
                className="form-check-input"
                type="checkbox"
                id="nonResident"
                value="non-resident"
              />
              <label>Includes Superannuation</label>
              <br />
              <small className="text-muted">
                Super is paid in addition to your salary
              </small>
            </div>
            <div className="form-check form-switch">
              <input
                onClick={() => setStudentLoan(!studentLoan)}
                className="form-check-input"
                type="checkbox"
                id="nonResident"
                value="student loan"
                disabled={workHoliDay}
              />
              <label>Student loan</label>
              <br />
              <small className="text-muted">
                HELP (HECS), VSL, TSL, SSL, SFSS
              </small>
            </div>
          </Col>
        </Row>

        <Row className="my-5">
          <Col md={6} sm={12}>
            {/* Superannuation */}
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="">
                <Accordion.Header>
                  {" "}
                  <span style={{ color: "green" }}>Superannuation</span>
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col md={6}>
                      <FloatingLabel
                        controlId="floatingInput"
                        label="Superannuation Rate"
                        className="mb-3"
                      >
                        <Form.Control
                          type="Number"
                          value={superannuation}
                          onChange={(e) =>
                            setSuperannuation(Number(e.target.value))
                          }
                          disabled={noSuperAnnuation}
                        />
                      </FloatingLabel>
                    </Col>
                    <Col md={6}>
                      {noSuperAnnuation ? null : (
                        <div>
                          <Form.Label className="mb-0">
                            Standard rate
                          </Form.Label>{" "}
                          <br />
                          <Button className="ms-2" variant="dark" size="sm">
                            Maximize
                          </Button>{" "}
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <div className="form-check  form-switch">
                      <input
                        onClick={() => {
                          setNoSuperAnnuation(!noSuperAnnuation);
                          setSuperannuation(0);
                        }}
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="no-super-annuation"
                      />
                      <label className="form-check-label">
                        No Superannuation Guarantee
                        <br />
                        <small className="text-muted">
                          Sole traders aren't obliged to pay Superannuation
                        </small>
                      </label>
                    </div>
                  </Row>
                  <Row>
                    <div className="form-check form-switch">
                      <input
                        onClick={() => setincomeSacrifice(!incomeSacrifice)}
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="income-sacrifice"
                        disabled={noSuperAnnuation}
                      />
                      <label className="form-check-label">
                        salary Sacrifice Superannuation
                        <br />
                        <small className="text-muted">
                          Reportable Superannuation contributions
                        </small>
                      </label>
                    </div>
                    {incomeSacrifice ? (
                      <Row className="my-3">
                        <Col md={6}>
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Amount"
                            className="mb-3"
                          >
                            <Form.Control
                              type="Number"
                              value={salarySacrifice}
                              onChange={(e) =>
                                setSalarySacrifice(Number(e.target.value))
                              }
                            />
                          </FloatingLabel>
                        </Col>
                        <Col md={6}>
                          <FloatingLabel
                            controlId="floatingSelectGrid"
                            label="Frequency"
                          >
                            <Form.Select
                              aria-label="Default select example"
                              onChange={(e) => getDataFrequency(e.target.value)}
                            >
                              {frequencys.map((data) => (
                                <option
                                  defaultValue={data.value}
                                  key={data.value}
                                >
                                  {data.value}
                                </option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Col>
                      </Row>
                    ) : null}
                  </Row>
                  <Row>
                    <div className="form-check form-switch">
                      <input
                        onClick={() =>
                          setVoluntarySuperAnnuation(!voluntarySuperAnnuation)
                        }
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="voluntary-super"
                      />
                      <label className="form-check-label">
                        Voluntary Superannuation
                        <br />
                        <small className="text-muted">
                          After tax personal contributions. You're eligible for
                          a{" "}
                          <a
                            href="https://www.ato.gov.au/individuals/super/in-detail/growing-your-super/super-co-contribution/"
                            target="_blank"
                            style={{ color: "#f1b441" }}
                            className="text-decoration-none"
                          >
                            Government co-contribution
                          </a>
                        </small>
                      </label>
                    </div>
                    {voluntarySuperAnnuation ? (
                      <div className="my-3">
                        <FloatingLabel
                          controlId="floatingInput"
                          label="Annual Contribution"
                          className="mb-3"
                        >
                          <Form.Control
                            type="Number"
                            value={voluntary}
                            onChange={(e) =>
                              setVoluntary(Number(e.target.value))
                            }
                          />
                        </FloatingLabel>

                        {over71 ? (
                          <div className="form-check d-none">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="maximize-govt"
                              onClick={() => setcoContribution(!coContribution)}
                            />

                            <label className="form-check-label">
                              Maximize Government super co-contribution
                            </label>
                          </div>
                        ) : (
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="maximize-govt"
                              onClick={() => setcoContribution(!coContribution)}
                            />

                            <label className="form-check-label">
                              Maximize Government super co-contribution
                            </label>
                          </div>
                        )}
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="over-71"
                            onClick={() => setOver71(!over71)}
                          />
                          <label className="form-check-label">Over 71</label>
                        </div>
                      </div>
                    ) : null}
                  </Row>
                  <Row>
                    <div className="form-check form-switch">
                      <input
                        onClick={() => setCarryForward(!carryForward)}
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="carry-forward-superannuation"
                      />
                      <label className="form-check-label">
                        Carry forward Superannuation
                        <br />
                        <small className="text-muted">
                          Unused contributions carried forward from previous
                          years will increase your concessional cap.{" "}
                          <a
                            href="https://www.ato.gov.au/individuals/super/in-detail/growing-your-super/super-contributions---too-much-can-mean-extra-tax/?page=6"
                            target="_blank"
                            style={{ color: "#f1b441" }}
                            className="text-decoration-none"
                          >
                            Limits apply.
                          </a>
                        </small>
                      </label>
                    </div>

                    {carryForward ? (
                      <div className="my-3">
                        <FloatingLabel
                          controlId="floatingInput"
                          label="Carry Forward Amount"
                          className="mb-3"
                        >
                          <Form.Control type="Number" placeholder="1" />
                        </FloatingLabel>
                      </div>
                    ) : null}
                  </Row>
                  <Row>
                    <div className="form-check form-switch">
                      <input
                        onClick={() => setContribution(!contribution)}
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="set-contribute"
                      />
                      <label className="form-check-label">
                        Contributions to Spouse's Super
                        <br />
                        <small className="text-muted">
                          <a
                            href="https://www.ato.gov.au/Individuals/myTax/2020/In-detail/Super-contributions-on-behalf-of-your-spouse/"
                            target="_blank"
                            style={{ color: "#f1b441" }}
                            className="text-decoration-none"
                          >
                            Check your eligibility for the tax offset
                          </a>
                        </small>
                      </label>
                    </div>
                    {contribution ? (
                      <Row className="my-3">
                        <Col md={6}>
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Spouse Income"
                            className="mb-3"
                          >
                            <Form.Control
                              type="Number"
                              id="dependent-number"
                              placeholder="1"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col md={6}>
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Contribution"
                            className="mb-3"
                          >
                            <Form.Control
                              type="Number"
                              id="dependent-number"
                              placeholder="1"
                            />
                          </FloatingLabel>
                        </Col>
                      </Row>
                    ) : null}
                  </Row>
                  <Row>
                    <div className="form-check form-switch">
                      {over71 ? (
                        <input
                          onClick={() => setOverSixtyFive(!overSixtyFive)}
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                          checked={over71}
                        />
                      ) : (
                        <input
                          onClick={() => setOverSixtyFive(!overSixtyFive)}
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                      )}

                      <label className="form-check-label">Over 65</label>
                      <br />
                      <small className="text-muted">
                        Your Superannuation fund cap is $330,000
                      </small>
                    </div>
                    {overSixtyFive ? null : null}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            {/* TaxCategory */}
            <Accordion defaultActiveKey="0" className="mt-3">
              <Accordion.Item eventKey="">
                <Accordion.Header>
                  <span style={{ color: "green" }}>Tax category</span>
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <div className="form-check form-switch">
                      <input
                        onClick={() => setNonResident(!nonResident)}
                        className="form-check-input"
                        type="checkbox"
                        id="nonResident"
                        value="non-resident"
                      />
                      <label>Non Resident</label>
                      <br />
                      <small className="text-muted">
                        Select if you're a visitor
                      </small>
                    </div>
                  </Row>
                  <Row>
                    <div className="form-check form-switch">
                      <input
                        onClick={() => setWorkHoliDay(!workHoliDay)}
                        className="form-check-input"
                        type="checkbox"
                        value="working-holiday"
                        id="work-holiday"
                        onChange={() => setNonResident(!nonResident)}
                      />
                      <label>Working Holiday Maker</label>
                      <br />
                      <small className="text-muted">
                        Visa 417, 462 (Backpacker)
                      </small>
                    </div>
                    {workHoliDay ? (
                      <div>
                        <div className="form-check form-switch">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="tax-file"
                            checked={workHoliDay}
                          />
                          <label className="form-check-label">
                            Tax File Number
                          </label>
                        </div>
                      </div>
                    ) : null}
                  </Row>
                  <Row>
                    <div className="form-check form-switch">
                      <input
                        onClick={() => setNoTaxFree(!noTaxFree)}
                        className="form-check-input"
                        type="checkbox"
                        value="no-tax-free"
                        id="no-tax-free"
                      />
                      <label>No tax-free threshold</label>
                      <br />
                      <small className="text-muted">
                        Apply for tax on a second job
                      </small>
                    </div>
                    {noTaxFree ? null : null}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
          <Col md={6} sm={12}>
            {/* Medicare */}
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <span style={{ color: "green" }}>
                    Medicare & Senior offset{" "}
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col md={6} className="ps-0">
                      <div className="form-check form-switch">
                        <input
                          onClick={() => setMedicare(!mediCare)}
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="medicare"
                          disabled={nonResident}
                        />
                        <label className="form-check-label">
                          Medicare Exemption{" "}
                        </label>
                        <br />
                        <small className="text-muted">
                          <a
                            href="https://www.ato.gov.au/Individuals/Medicare-and-private-health-insurance/Medicare-levy/medicare-levy-exemption/"
                            target="_blank"
                            style={{ color: "#f1b441" }}
                            className="text-decoration-none"
                          >
                            Check your eligibility{" "}
                          </a>
                        </small>
                      </div>
                    </Col>
                    <Col md={6}>
                      {mediCare ? (
                        <div>
                          <Form.Select aria-label="Default select example">
                            <option value="1">Full</option>
                            <option value="2">Half</option>
                          </Form.Select>
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                  <Row>
                    <div className="form-check form-switch">
                      <input
                        onClick={() => setDependent(!dependent)}
                        className="form-check-input"
                        type="checkbox"
                        value="Dependant Children"
                        disabled={nonResident}
                      />
                      <label className="form-check-label">
                        Dependant Children
                      </label>
                      <br />
                      <small className="text-muted">
                        <a
                          href="https://www.ato.gov.au/Individuals/Medicare-and-private-health-insurance/Medicare-levy/Medicare-levy-exemption/Dependants-for-Medicare-levy-exemption/"
                          target="_blank"
                          style={{ color: "#f1b441" }}
                          className="text-decoration-none"
                        >
                          Check the eligibility of dependant children
                        </a>
                      </small>
                    </div>
                    {dependent ? (
                      <div className="my-3">
                        <FloatingLabel
                          controlId="floatingInput"
                          label="Number Of Dependent"
                          className="mb-3"
                        >
                          <Form.Control
                            type="Number"
                            id="no-children"
                            placeholder="1"
                          />
                        </FloatingLabel>

                        {/* <div className="form-check form-switch">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="apply-medicare"
                          />
                          <label className="form-check-label">
                            Apply Medicare Adjustment
                          </label>
                        </div> */}

                        <FloatingLabel
                          controlId="floatingInput"
                          label="Child Support Payment"
                          className="mb-3"
                        >
                          <Form.Control
                            type="Number"
                            id="child-support"
                            placeholder="1"
                          />
                        </FloatingLabel>
                      </div>
                    ) : null}
                  </Row>
                  <Row>
                    <div className="form-check form-switch">
                      <input
                        onClick={() => setSpouse(!spouse)}
                        className="form-check-input"
                        type="checkbox"
                        value="set-spouse"
                        id="set-spouse"
                        disabled={nonResident}
                      />
                      <label className="form-check-label">
                        Spouse (married or de-facto)
                      </label>
                    </div>
                    {spouse ? (
                      <div className="my-3">
                        <FloatingLabel
                          controlId="floatingInput"
                          label="Spouse Annual Income"
                          className="mb-3"
                        >
                          <Form.Control
                            type="Number"
                            id="spouse-annual"
                            placeholder="1"
                          />
                        </FloatingLabel>
                      </div>
                    ) : null}
                  </Row>
                  <Row>
                    <div className="form-check form-switch">
                      <input
                        onClick={() => setSapto(!sapto)}
                        className="form-check-input"
                        type="checkbox"
                        value="sapto"
                      />
                      <label className="form-check-label">
                        Senior & pensioner offset (SAPTO)
                      </label>
                      <br />
                      <small className="text-muted">
                        Refer to{" "}
                        <a
                          href="https://www.ato.gov.au/calculators-and-tools/beneficiary-tax-offset-and-seniors-and-pensioner-tax-offset-calculator/"
                          target="_blank"
                          style={{ color: "#f1b441" }}
                          className="text-decoration-none"
                        >
                          {" "}
                          eligibility criteria{" "}
                        </a>
                      </small>
                    </div>
                    {sapto ? null : null}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            {/* Deductions, income Sacrifice & Other income */}
            <Accordion defaultActiveKey="0" className="my-3">
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <span style={{ color: "green" }}>
                    Deductions, income Sacrifice & Other income
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col xs={12} md={12}>
                      <FloatingLabel
                        controlId="floatingInput"
                        label="Annual Tax Deduction"
                        className="mb-3"
                      >
                        <Form.Control
                          value={deductions}
                          onChange={(e) =>
                            setDeductions(Number(e.target.value))
                          }
                          type="Number"
                          placeholder="Input Amount"
                        />
                        <small className="text-muted ms-2">
                          Applied to annual calculations
                        </small>
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={6}>
                      <FloatingLabel
                        controlId="floatingInput"
                        label="income Sacrifice"
                        className=""
                      >
                        <Form.Control
                          type="Number"
                          placeholder="Input Amount"
                          value={salarySacrafice}
                          onChange={(e) =>
                            setSalarySacrafice(Number(e.target.value))
                          }
                        />
                      </FloatingLabel>
                    </Col>
                    <Col md={6}>
                      <FloatingLabel
                        controlId="floatingSelectGrid"
                        label="Frequency"
                      >
                        <Form.Select
                          aria-label="Default select example"
                          onChange={(e) => getDataFrequencyTwo(e.target.value)}
                        >
                          {frequencysTwo.map((data) => (
                            <option defaultValue={data.value} key={data.value}>
                              {data.value}
                            </option>
                          ))}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <small className="text-muted ms-2">
                      Salary Sacrifice arrangment not including salary
                      sacrificed super
                    </small>
                  </Row>
                  <Row>
                    <Col xs={12} md={12}>
                      <FloatingLabel
                        controlId="floatingInput"
                        label="Capital Gains"
                        className="mb-3"
                      >
                        <Form.Control
                          type="Number"
                          placeholder="Input Amount"
                          value={capitalGains}
                          onChange={(e) =>
                            setCapitalGains(Number(e.target.value))
                          }
                        />
                        <small className="text-muted ms-2">
                          Annual reportable{" "}
                          <a
                            href="https://www.ato.gov.au/Individuals/Capital-gains-tax/?=redirected_URL"
                            target="_blank"
                            className="text-decoration-none"
                            style={{ color: "#f1b441" }}
                          >
                            Capital Gains
                          </a>
                        </small>
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={6}>
                      <FloatingLabel
                        controlId="floatingInput"
                        label="Allowances"
                        className=""
                      >
                        <Form.Control
                          type="Number"
                          value={allowances}
                          onChange={(e) =>
                            setAllowances(Number(e.target.value))
                          }
                          placeholder="Input Amount"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col md={6}>
                      <FloatingLabel
                        controlId="floatingSelectGrid"
                        label="Year"
                      >
                        <Form.Select
                          aria-label="Default select example"
                          onChange={(e) =>
                            getDataFrequencyThree(e.target.value)
                          }
                        >
                          {frequencysThree.map((data) => (
                            <option defaultValue={data.value} key={data.value}>
                              {data.value}
                            </option>
                          ))}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <small className="text-muted ms-2">
                      Tax witholding and superannuation guarantee apply.
                      Excludes{" "}
                      <a
                        href="https://www.ato.gov.au/business/payg-withholding/payments-you-need-to-withhold-from/payments-to-employees/allowances-and-reimbursements/withholding-for-allowances/"
                        target="_blank"
                        className="text-decoration-none"
                        style={{ color: "#f1b441" }}
                      >
                        other types of allowances.
                      </a>
                    </small>
                  </Row>
                  <Row>
                    <Col xs={12} md={12}>
                      <FloatingLabel
                        controlId="floatingInput"
                        label="Other Income or Loss"
                        className="mb-3"
                      >
                        <Form.Control
                          type="Number"
                          placeholder="Input Amount"
                          value={otherIncome}
                          onChange={(e) =>
                            setOtherIncome(Number(e.target.value))
                          }
                        />
                        <small className="text-muted ms-2">
                          Check categories of{" "}
                          <a
                            href="https://www.ato.gov.au/Individuals/Tax-return/2021/Supplementary-tax-return/Income-questions-13-24/24-Other-income-2021/"
                            target="_blank"
                            className="text-decoration-none"
                            style={{ color: "#f1b441" }}
                          >
                            other income.
                          </a>
                          Use negative value for a loss.
                        </small>
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={12}>
                      <FloatingLabel
                        controlId="floatingInput"
                        label="Business Income"
                        className="mb-3"
                      >
                        <Form.Control
                          type="Number"
                          value={businessIncome}
                          onChange={(e) =>
                            setBusinessIncome(Number(e.target.value))
                          }
                          placeholder="Input Amount"
                        />
                        <small className="text-muted ms-2">
                          Small business or sole-trader income{" "}
                        </small>
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={12}>
                      <FloatingLabel
                        controlId="floatingInput"
                        label="Tax Credit"
                        className="mb-3"
                      >
                        <Form.Control
                          type="Number"
                          placeholder="Input Amount"
                          value={taxCredits}
                          onChange={(e) =>
                            setTaxCredits(Number(e.target.value))
                          }
                        />
                        <small className="text-muted ms-2">
                          Tax credits such as franking credits.{" "}
                        </small>
                      </FloatingLabel>
                    </Col>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>

        <Row>
          <Table borderless style={{ marginLeft: "25px", color: "#7ea437" }}>
            <tbody>
              <tr>
                <th style={{ width: "520px" }}></th>
                <th style={{ width: "120px" }}>
                  {(dateType === "Daily" || dateType === "Hourly") && (
                    <span>Daily</span>
                  )}
                </th>
                <th style={{ width: "120px" }}>Weekly</th>
                <th style={{ width: "120px" }}>FortNightly</th>
                <th style={{ width: "120px" }}>Monthly</th>
                <th>Annually</th>
              </tr>
              {/* <tr>
                <th className="border-0 fs-4" style={{ width: "520px" }}></th>
                <th className="border-0" style={{ width: "120px" }}>
                  {(dateType === "Daily" || dateType === "Hourly") && (
                    <span>Daily</span>
                  )}
                </th>
                <th className="border-0" style={{ width: "120px" }}>
                  Weekly
                </th>
                <th className="border-0" style={{ width: "120px" }}>
                  FortNightly
                </th>
                <th className="border-0" style={{ width: "120px" }}>
                  Monthly
                </th>
                <th className="border-0">Annually</th>
              </tr> */}
            </tbody>
          </Table>
          <Accordion>
            <Accordion.Item
              eventKey="0"
              style={{
                backgroundColor: "#7ea437",
              }}
            >
              <Table borderless>
                <tbody>
                  {/* <tr>
                    <th className="border-0 fs-4" style={{ width: "520px" }}>
                      Pay
                    </th>
                    <th className="border-0" style={{ width: "120px" }}>
                      {(dateType === "Daily" || dateType === "Hourly") && (
                        <span>Daily</span>
                      )}
                    </th>
                    <th className="border-0" style={{ width: "120px" }}>
                      Weekly
                    </th>
                    <th className="border-0" style={{ width: "120px" }}>
                      FortNightly
                    </th>
                    <th className="border-0" style={{ width: "120px" }}>
                      Monthly
                    </th>
                    <th className="border-0">Annually</th>
                  </tr> */}
                  <tr>
                    <th className="border-0" style={{ width: "520px" }}>
                      Pay
                    </th>
                    <th
                      className="border-0 text-right"
                      style={{ width: "120px" }}
                    >
                      {(dateType === "Daily" || dateType === "Hourly") && (
                        <span>${dailyTaxableIncome.toFixed(2)}</span>
                      )}
                    </th>
                    <th
                      className="border-0 text-right"
                      style={{ width: "120px" }}
                    >
                      ${weaklyTaxableIncome.toFixed(2)}
                    </th>
                    <th
                      className="border-0 text-right"
                      style={{ width: "120px" }}
                    >
                      ${fortnightlyTaxableIncome.toFixed(2)}
                    </th>
                    <th
                      className="border-0 text-right"
                      style={{ width: "135px" }}
                    >
                      ${monthlyTaxableIncome.toFixed(2)}
                    </th>
                    <th className="border-0 text-right">
                      ${annuallyTaxableIncome}
                    </th>
                  </tr>
                </tbody>
              </Table>
              {/* <Accordion.Header>
              </Accordion.Header> */}
            </Accordion.Item>
          </Accordion>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <Table>
                  <tbody>
                    <tr>
                      <th className="border-0" style={{ width: "520px" }}>
                        Taxable Income
                      </th>
                      <th className="border-0" style={{ width: "120px" }}>
                        {(dateType === "Daily" || dateType === "Hourly") && (
                          <span>${dailyTaxableIncome.toFixed(2)}</span>
                        )}
                      </th>
                      <th className="border-0" style={{ width: "120px" }}>
                        ${weaklyTaxableIncome.toFixed(2)}
                      </th>
                      <th className="border-0" style={{ width: "120px" }}>
                        ${fortnightlyTaxableIncome.toFixed(2)}
                      </th>
                      <th className="border-0" style={{ width: "135px" }}>
                        ${monthlyTaxableIncome.toFixed(2)}
                      </th>
                      <th className="border-0">${annuallyTaxableIncome}</th>
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Header>
              <Accordion.Body>
                <Table>
                  <tbody>
                    <tr>
                      <th className="fw-normal" style={{ width: "520px" }}>
                        Base Salary
                      </th>
                      <th className=" fw-normal" style={{ width: "120px" }}>
                        {(dateType === "Daily" || dateType === "Hourly") && (
                          <span>${dailyTaxableIncome.toFixed(2)}</span>
                        )}
                      </th>
                      <th className="fw-normal" style={{ width: "120px" }}>
                        ${weaklyTaxableIncome.toFixed(2)}
                      </th>
                      <th className="fw-normal" style={{ width: "120px" }}>
                        ${fortnightlyTaxableIncome.toFixed(2)}
                      </th>
                      <th className="fw-normal" style={{ width: "120px" }}>
                        ${monthlyTaxableIncome.toFixed(2)}
                      </th>
                      <th className="fw-normal">${annuallyTaxableIncome}</th>
                    </tr>
                    {includesSup ? (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Superannuation <br />
                          <small className="fw-normal text-muted">
                            Taken from your salary
                          </small>
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>
                              ($
                              {(
                                (dailyTaxableIncome / 100) *
                                includesSup
                              ).toFixed(2)}
                              )
                            </span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          ($
                          {((weaklyTaxableIncome / 100) * includesSup).toFixed(
                            2
                          )}
                          )
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          ($
                          {(
                            (fortnightlyTaxableIncome / 100) *
                            includesSup
                          ).toFixed(2)}
                          )
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          ($
                          {((monthlyTaxableIncome / 100) * includesSup).toFixed(
                            2
                          )}
                          )
                        </th>
                        <th className="fw-normal">
                          ($
                          {(
                            (annuallyTaxableIncome / 100) *
                            includesSup
                          ).toFixed(2)}
                          )
                        </th>
                      </tr>
                    ) : null}

                    {incomeSacrifice && (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Salary sacrifice
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>${percentSalarySacrifice.toFixed(2)}</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          - ${weaklySalarySacrifice.toFixed(2)}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          - ${fortnightlySalarySacrifice.toFixed(2)}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          - ${monthlySalarySacrifice.toFixed(2)}
                        </th>
                        <th className="fw-normal">
                          - ${annuallySalarySacrifice.toFixed(2)}
                        </th>
                      </tr>
                    )}

                    {over71 && (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Concessional voluntary Super
                          <br />
                          <small className="fw-normal text-muted">
                            Taxable deduction
                          </small>
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal">- ${voluntary.toFixed(2)}</th>
                      </tr>
                    )}

                    {deductions && (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Deductions
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal">
                          - ${deductions.toFixed(2)}
                        </th>
                      </tr>
                    )}

                    {salarySacrafice ? (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Salary Sacrafice
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {/* <span style={{ display: "none" }} id="show14">
                            
                          </span> */}
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>- ${percentSalarySacrafice.toFixed(2)}</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          - ${weaklySalarySacrafice.toFixed(2)}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          - ${fortnightlySalarySacrafice.toFixed(2)}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          - ${monthlySalarySacrafice.toFixed(2)}
                        </th>
                        <th className="fw-normal">
                          - ${annuallySalarySacrafice.toFixed(2)}
                        </th>
                      </tr>
                    ) : null}

                    {capitalGains ? (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Capital Gains
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal">
                          ${capitalGains.toFixed(2)}
                        </th>
                      </tr>
                    ) : null}

                    {otherIncome ? (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Other Income
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal">${otherIncome.toFixed(2)}</th>
                      </tr>
                    ) : null}

                    {businessIncome ? (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Business Income
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal">
                          ${businessIncome.toFixed(2)}
                        </th>
                      </tr>
                    ) : null}

                    {allowances ? (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Allowances
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          ${weaklyAllowances.toFixed(2)}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          ${fortnightlyAllowances.toFixed(2)}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          ${monthlyAllowances.toFixed(2)}
                        </th>
                        <th className="fw-normal">
                          ${annuallyAllowances.toFixed(2)}
                        </th>
                      </tr>
                    ) : null}
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <Accordion defaultActiveKey="1">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <Table>
                  <tbody>
                    <tr>
                      <th className="border-0" style={{ width: "520px" }}>
                        Superannuation
                      </th>
                      <th className="border-0" style={{ width: "120px" }}>
                        {/* <span style={{ display: "none" }} id="show4">
                          
                        </span> */}
                        {(dateType === "Daily" || dateType === "Hourly") && (
                          <span>
                            $
                            {(
                              (dailyTaxableIncome / 100) *
                              superannuation
                            ).toFixed(2)}{" "}
                          </span>
                        )}
                      </th>
                      <th className="border-0" style={{ width: "120px" }}>
                        $
                        {((weaklyTaxableIncome / 100) * superannuation).toFixed(
                          2
                        )}
                      </th>
                      <th className="border-0" style={{ width: "120px" }}>
                        $
                        {(
                          (fortnightlyTaxableIncome / 100) *
                          superannuation
                        ).toFixed(2)}
                      </th>
                      <th className="border-0" style={{ width: "120px" }}>
                        $
                        {(
                          (monthlyTaxableIncome / 100) *
                          superannuation
                        ).toFixed(2)}
                      </th>
                      <th className="border-0">
                        $
                        {(
                          (annuallyTaxableIncome / 100) *
                          superannuation
                        ).toFixed(2)}
                      </th>
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Header>
              <Accordion.Body>
                <Table>
                  <tbody>
                    <tr>
                      <th className="fw-normal" style={{ width: "520px" }}>
                        Super guarantee
                      </th>
                      <th className="fw-normal" style={{ width: "120px" }}>
                        {(dateType === "Daily" || dateType === "Hourly") && (
                          <span>
                            $
                            {(
                              (dailyTaxableIncome / 100) *
                              superannuation
                            ).toFixed(2)}
                          </span>
                        )}
                      </th>
                      <th className="fw-normal" style={{ width: "120px" }}>
                        $
                        {((weaklyTaxableIncome / 100) * superannuation).toFixed(
                          2
                        )}
                      </th>
                      <th className="fw-normal" style={{ width: "120px" }}>
                        $
                        {(
                          (fortnightlyTaxableIncome / 100) *
                          superannuation
                        ).toFixed(2)}
                      </th>
                      <th className="fw-normal" style={{ width: "120px" }}>
                        $
                        {(
                          (monthlyTaxableIncome / 100) *
                          superannuation
                        ).toFixed(2)}
                      </th>
                      <th className="fw-normal">
                        $
                        {(annuallyTaxableIncome / 100) *
                          superannuation.toFixed(2)}
                      </th>
                    </tr>
                    {coContribution && (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Co-Contribution
                          <br />
                          <small className="fw-normal text-muted">
                            Government contribution
                          </small>
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {/* <span style={{ display: "none" }} id="show13">
                            -
                          </span> */}
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal">
                          $
                          {voluntary.toFixed(2) <= 40
                            ? 20
                            : Math.ceil(voluntary / 2)}
                        </th>
                      </tr>
                    )}

                    {incomeSacrifice && (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Reportable Contributions
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {/* <span style={{ display: "none" }} id="show13">
                            
                          </span> */}
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>${percentSalarySacrifice.toFixed(2)}</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          ${weaklySalarySacrifice.toFixed(2)}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          ${fortnightlySalarySacrifice.toFixed(2)}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          ${monthlySalarySacrifice.toFixed(2)}
                        </th>
                        <th className="fw-normal">
                          ${annuallySalarySacrifice.toFixed(2)}
                        </th>
                      </tr>
                    )}

                    {voluntarySuperAnnuation && (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Voluntary Contributions
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {/* <span style={{ display: "none" }} id="show13">
                            -
                          </span> */}
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal">${voluntary.toFixed(2)}</th>
                      </tr>
                    )}
                    <tr>
                      <th className="fw-normal">
                        Tax Offset
                        <br />
                        <small className="fw-normal text-muted">
                          Low income super tax offset (maximum)
                        </small>
                      </th>
                      <th>
                        {/* <span style={{ display: "none" }} id="show6">
                          -
                        </span> */}
                        {(dateType === "Daily" || dateType === "Hourly") && (
                          <span>-</span>
                        )}
                      </th>
                      <th>-</th>
                      <th>-</th>
                      <th>-</th>
                      <th className=" fw-normal">
                        [-${(annuallyTaxableIncome / 66.5).toFixed(2)}]
                      </th>
                    </tr>
                    <tr>
                      <th className="fw-normal">
                        Tax
                        <br />
                        <small className="fw-normal text-muted">
                          Tax taken from your super fund. Includes offset.
                        </small>
                      </th>
                      <th>
                        {/* <span style={{ display: "none" }} id="show7">
                          -
                        </span> */}
                        {(dateType === "Daily" || dateType === "Hourly") && (
                          <span>-</span>
                        )}
                      </th>
                      <th>-</th>
                      <th>-</th>
                      <th>-</th>
                      <th className=" fw-normal">[$0]</th>
                    </tr>
                    <tr>
                      <th className="fw-normal text-muted">Concessional</th>
                      <th>
                        {/* <span style={{ display: "none" }} id="show8">
                          -
                        </span> */}
                        {(dateType === "Daily" || dateType === "Hourly") && (
                          <span>-</span>
                        )}
                      </th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th className="fw-normal text-muted">
                        ${(annuallyTaxableIncome / 100) * superannuation}
                      </th>
                    </tr>
                    <tr>
                      <th className="fw-normal text-muted">Non-concessional</th>
                      <th className="text-muted">
                        {/* <span style={{ display: "none" }} id="show9"></span> */}
                        {(dateType === "Daily" || dateType === "Hourly") && (
                          <span></span>
                        )}
                      </th>
                      <th className=" text-muted"></th>
                      <th className=" text-muted"></th>
                      <th className=" text-muted"></th>
                      <th className="fw-normal text-muted">$0</th>
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <Accordion defaultActiveKey="2">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <Table>
                  <tbody>
                    <tr>
                      <th className="border-0" style={{ width: "520px" }}>
                        Tax
                      </th>
                      <th
                        className="fw-normal border-0"
                        style={{ width: "120px" }}
                      >
                        {/* <span style={{ display: "none" }} id="show10">
                          -
                        </span> */}
                        {(dateType === "Daily" || dateType === "Hourly") && (
                          <span>-</span>
                        )}
                      </th>
                      <th
                        className="fw-normal border-0"
                        style={{ width: "120px" }}
                      >
                        -
                      </th>
                      <th
                        className="fw-normal border-0"
                        style={{ width: "120px" }}
                      >
                        -
                      </th>
                      <th
                        className="fw-normal border-0"
                        style={{ width: "120px" }}
                      >
                        -
                      </th>
                      <th className="fw-normal border-0">$0</th>
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Header>
              <Accordion.Body>
                <Table>
                  <tbody>
                    <tr>
                      <th className="fw-normal" style={{ width: "520px" }}>
                        Income tax
                      </th>
                      <th style={{ width: "120px" }}>
                        {/* <span style={{ display: "none" }} id="show11"></span> */}
                        {(dateType === "Daily" || dateType === "Hourly") && (
                          <span></span>
                        )}
                      </th>
                      <th style={{ width: "120px" }}></th>
                      <th style={{ width: "120px" }}></th>
                      <th style={{ width: "120px" }}></th>
                      <th className="fw-normal">
                        ${(annuallyTaxableIncome / 100) * superannuation}
                      </th>
                    </tr>
                    <tr>
                      <th className="fw-normal">
                        Medicare <br />
                        <small className="fw-normal text-muted">
                          Senior, Single, no dependants.
                        </small>
                      </th>
                      <th>
                        {/* <span style={{ display: "none" }} id="show12">
                          -
                        </span> */}
                        {(dateType === "Daily" || dateType === "Hourly") && (
                          <span>-</span>
                        )}
                      </th>
                      <th>-</th>
                      <th>-</th>
                      <th>-</th>
                      <th className="fw-normal">
                        ${annuallyTaxableIncome / 100}
                      </th>
                    </tr>
                    {income ? (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          LMITO <br />
                          <small className="fw-normal text-muted">
                            Low And Middle Income Tax Offset
                          </small>
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal">-${income.toFixed(2)}</th>
                      </tr>
                    ) : null}
                    {income ? (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          LITO <br />
                          <small className="fw-normal text-muted">
                            Low Income Tax Offset
                          </small>
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal">-${income.toFixed(2)}</th>
                      </tr>
                    ) : null}
                    {sapto ? (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          SAPTO
                          <br />
                          <small className="fw-normal text-muted">
                            Seniors And Pensioners Tax Offset
                          </small>
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal">-${income.toFixed(2)}</th>
                      </tr>
                    ) : null}

                    {taxCredits ? (
                      <tr>
                        <th className="fw-normal" style={{ width: "515px" }}>
                          Business Income
                        </th>
                        <th className=" fw-normal" style={{ width: "120px" }}>
                          {(dateType === "Daily" || dateType === "Hourly") && (
                            <span>-</span>
                          )}
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal" style={{ width: "120px" }}>
                          -
                        </th>
                        <th className="fw-normal">
                          - ${taxCredits.toFixed(2)}
                        </th>
                      </tr>
                    ) : null}
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <Accordion style={{ marginBottom: "20px" }} defaultActiveKey="3">
            <Accordion.Item eventKey="0">
              <Table>
                <tbody>
                  <tr>
                    <th className="border-0" style={{ width: "610px" }}>
                      Estimated Tax Return
                    </th>
                    <th className="border-0" style={{ width: "120px" }}></th>
                    <th className="border-0" style={{ width: "120px" }}></th>
                    <th className="border-0" style={{ width: "120px" }}></th>
                    <th className="border-0 text-center fw-normal">$0</th>
                  </tr>
                </tbody>
              </Table>
            </Accordion.Item>
          </Accordion>
        </Row>
      </Container>
    </>
  );
};

export default DetailsCalc;
